export default {"src":"/_next/static/media/bell-icon-active.53714403.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};